module.exports = __webpack_public_path__ + "img/IMG_9458_59_60_FoamcoreMatted.0b7cc429.jpg";